import React from 'react';
import Button from 'components/Button/Button';
import Modal from '../Modal/Modal';
import styles from './MarusiaHelpModal.module.css';

type Props = { onClose: () => void };

const MarusiaHelpModal = ({ onClose }: Props) => {
  return (
    <Modal onClose={onClose} useCloseBtn={false}>
      <div className={styles.wrapper}>
        <div className={styles.close} onClick={onClose}>
          <div className={styles.cross} />
        </div>
        <div className={styles.icon}>
          <img
            src="https://static.uchi.ru/files/otvety/marusia/marusia_help_icon.svg"
            alt=""
          />
        </div>
        <h2 className={styles.title}>Маруся старается, но она бывает неправа</h2>
        <h4 className={styles.subtitle}>
          С&nbsp;ответом что-то не&nbsp;так? Жми&nbsp;
          <img
            alt="Пожаловаться"
            src="https://static.uchi.ru/files/otvety/report_flag.svg"
            className={styles.report_image}
          />
          &nbsp;<span className={styles.underlined_report}>Пожаловаться</span>
          &nbsp;&mdash; мы&nbsp;разберёмся
        </h4>
        <Button text="Понятно" onClick={onClose} className={styles.button} />
        <div className={styles.close_button}></div>
      </div>
    </Modal>
  );
};

export default MarusiaHelpModal;
